<div class="container-fluid py-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h4 class="mb-0">
      <i class="bi bi-persons text-warning me-2"></i>{{ 'admin_users.list_title' | translate }}
    </h4>
    <div>
      <button class="btn btn-outline-primary me-2" (click)="addClient()">
        <i class="bi bi-building me-2"></i>{{ 'admin_users.new_client' | translate }}
      </button>
      <button class="btn btn-accent" (click)="addUser()">
        <i class="bi bi-plus me-2"></i>{{ 'admin_users.new_user' | translate }}
      </button>
    </div>
  </div>

  <div class="card">
    <div class="card-body">
      <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" (activeIdChange)="onTabChange()" class="nav-tabs">
        <li [ngbNavItem]="1">
          <a ngbNavLink>
            <i class="bi bi-persons me-2"></i>{{ 'admin_users.tab_users' | translate }}
          </a>
          <ng-template ngbNavContent>
            <s-table [cols]="tabUsers.cols" [refreshUrl]="tabUsers.refreshUrl"
              [detailUrl]="tabUsers.detailUrl" [detailId]="tabUsers.detailId"
              [showPageSize]="!shared.isMobileConst">
            </s-table>
          </ng-template>
        </li>
        <li [ngbNavItem]="2">
          <a ngbNavLink>
            <i class="bi bi-building me-2"></i>{{ 'admin_users.tab_clients' | translate }}
          </a>
          <ng-template ngbNavContent>
            <s-table [cols]="tabClients.cols" [refreshUrl]="tabClients.refreshUrl"
              [detailUrl]="tabClients.detailUrl" [detailId]="tabClients.detailId"
              [showPageSize]="!shared.isMobileConst">
            </s-table>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav" class="mt-3"></div>
    </div>
  </div>
</div>
